var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4177 13.0834H105.583L143.917 51.4176V105.583L105.583 143.917H51.4177L13.0835 105.583V51.4176L51.4177 13.0834Z",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 52.3334V78.5001",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 104.667H78.5643",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/WarningSign.7fbe6e511901baf79cb5a3463919bb83.svg";
export { ForwardRef as ReactComponent };